import type { Inventory } from '.';

import { createMessage, createMessages, SB } from '@play-co/replicant';

export const inventoryMessages = (
  Inventory: Pick<Inventory, 'schema' | 'modifiers'>,
  { Pet }: Inventory['$DEPENDENCIES'],
) =>
  createMessages(SB.object({ ...Inventory.schema, ...Pet.schema }))({
    /**
     * Add free gems to target user state
     */
    addFreeGems: createMessage(SB.number(), (state, amount) => {
      Inventory.modifiers(state).addFreeGems(amount);
    }),
  });
